module.exports = ":host {\n  display:block;\n}\n\n.content {\n  padding:5rem;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/code-slide/code-slide.component.css
// module id = ./src/app/code-slide/code-slide.component.css
// module chunks = main